import React, { useEffect } from "react";
import Background_Member2 from "../../assets/images/inner-banner.jpg";
import { Link } from "react-router-dom";

const AlliedProfessions = () => {
  document.title =
    "Allied and Healthcare Professions | Gujarat State Allied and Healthcare Council";
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      {/* <div
                className="banner-image wrappermain"
                style={{
                    backgroundImage: "url(" + Background_Member2 + ")",
                    backgroundSize: "fill",
                    backgroundPosit
                    ion: "bottom",
                    backgroundRepeat: "no-repeat",
                    padding: "45px 0",
                }}
            >
                <div className="banner-inner-breadcrumb">
                    <div className="container">
                        <nav aria-label="breadcrumb">
                            <ul className="breadcrumb">
                                <li className="breadcrumb-item"><a href="/">Home</a></li>
                                <li className="breadcrumb-item"><a href="/about-us">About Us</a></li>
                                <li className="breadcrumb-item active" aria-current="page">Allied and Healthcare Professions</li>
                            </ul>
                        </nav>
                    </div>
                </div>
            </div> */}
      <div className="wrappermain">
        <section className="home-faq-main-banner p-b-60">
          <div className="container">
            <h2 className="p-t-60 text-center section-title text-white">
              Categories under
              <br /> NCAHP Act
            </h2>
            <div className="faq-box-main">
              <div className="row">
                <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12">
                  <div id="accordion">
                    <div className="card">
                      <div className="card-header">
                        <a
                          className="collapsed card-link accordion-title"
                          data-toggle="collapse"
                          href="#collapseone"
                        >
                          1. Medical Laboratory and Life Science
                        </a>
                      </div>
                      <div
                        id="collapseone"
                        className="collapse"
                        data-parent="#accordion"
                      >
                        <div className="card-body">
                          <table className="table">
                            <tbody>
                              <tr>
                                <th>Life Science Professional </th>
                                <th>ISCO Code </th>
                              </tr>
                              <tr>
                                <td>(i) Biotechnologist</td>
                                <td>2131</td>
                              </tr>
                              <tr>
                                <td>(ii) Biochemist (nonclinical)</td>
                                <td></td>
                              </tr>
                              <tr>
                                <td>(iii) Cell Geneticist</td>
                                <td></td>
                              </tr>
                              <tr>
                                <td>(iv) Microbiologist (nonclinical)</td>
                                <td></td>
                              </tr>
                              <tr>
                                <td>(v) Molecular Biologist (nonclinical)</td>
                                <td></td>
                              </tr>
                              <tr>
                                <td>(vi) Molecular Geneticist</td>
                                <td></td>
                              </tr>
                            </tbody>
                          </table>
                          <table className="table mt-3">
                            <tbody>
                              <tr>
                                <th>
                                  Medical Laboratory Sciences Professional{" "}
                                </th>
                                <th>ISCO Code </th>
                              </tr>
                              <tr>
                                <td>(i) Cytotechnologist </td>
                                <td>3212</td>
                              </tr>
                              <tr>
                                <td>(ii) Forensic Science Technologist </td>
                                <td></td>
                              </tr>
                              <tr>
                                <td>(iii) Histotechnologist</td>
                                <td></td>
                              </tr>
                              <tr>
                                <td>(iv) Hemato Technologist </td>
                                <td></td>
                              </tr>
                              <tr>
                                <td>(v) Medical Lab Technologist </td>
                                <td></td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                    <div className="card">
                      <div className="card-header">
                        <a
                          className="collapsed card-link accordion-title"
                          data-toggle="collapse"
                          href="#collapsetwo"
                        >
                          2. Trauma, Burn Care and Surgical/ Anesthesia related
                          technology
                        </a>
                      </div>
                      <div
                        id="collapsetwo"
                        className="collapse"
                        data-parent="#accordion"
                      >
                        <div className="card-body">
                          <table className="table">
                            <tbody>
                              <tr>
                                <th>Trauma and Burn Care Professional </th>
                                <th>ISCO Code </th>
                              </tr>
                              <tr>
                                <td>(i) Advance Care Paramedic </td>
                                <td>2240</td>
                              </tr>
                              <tr>
                                <td>(ii) Burn Care Technologist </td>
                                <td>2240</td>
                              </tr>
                              <tr>
                                <td>
                                  (iii) Emergency Medical Technologist
                                  (Paramedic){" "}
                                </td>
                                <td>3258</td>
                              </tr>
                            </tbody>
                          </table>
                          <table className="table mt-3">
                            <tbody>
                              <tr>
                                <th>
                                  Surgical and Anaesthesia-related Technology
                                  Professional{" "}
                                </th>
                                <th>ISCO Code </th>
                              </tr>
                              <tr>
                                <td>
                                  (i) Anaesthesia Assistants and Technologists
                                </td>
                                <td>3259</td>
                              </tr>
                              <tr>
                                <td>
                                  (ii) Operation Theatre (OT)Technologists{" "}
                                </td>
                                <td>3259</td>
                              </tr>
                              <tr>
                                <td>
                                  (iii) Endoscopy and Laparoscopy Technologists
                                </td>
                                <td>3259</td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                    <div className="card">
                      <div className="card-header">
                        <a
                          className="collapsed card-link accordion-title"
                          data-toggle="collapse"
                          href="#collapsethree"
                        >
                          3. Physiotherapy Professional
                        </a>
                      </div>
                      <div
                        id="collapsethree"
                        className="collapse"
                        data-parent="#accordion"
                      >
                        <div className="card-body">
                          <div className="d-flex justify-content-between pb-2">
                            {/* <Link to={"/guidelines"} className="btn-login">Guidelines</Link>
                            <Link to={"/login"} className="btn-login">Login</Link> */}
                          </div>
                          <table className="table">
                            <tbody>
                              <tr>
                                <th>Profession </th>
                                <th>ISCO Code </th>
                              </tr>
                              <tr>
                                <td>Physiotherapist</td>
                                <td>2264</td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                    <div className="card">
                      <div className="card-header">
                        <a
                          className="collapsed card-link accordion-title"
                          data-toggle="collapse"
                          href="#collapsefour"
                        >
                          4. Nutrition Science Professional
                        </a>
                      </div>
                      <div
                        id="collapsefour"
                        className="collapse"
                        data-parent="#accordion"
                      >
                        <div className="card-body">
                          <table className="table">
                            <tbody>
                              <tr>
                                <th>Profession </th>
                                <th>ISCO Code </th>
                              </tr>
                              <tr>
                                <td>
                                  (i) Dietician (including Clinical Dietician,
                                  Food Service Dietician){" "}
                                </td>
                                <td>2265</td>
                              </tr>
                              <tr>
                                <td>
                                  (ii) Nutritionist (including Public Health
                                  Nutritionist, Sports Nutritionist){" "}
                                </td>
                                <td>2265</td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                    <div className="card">
                      <div className="card-header">
                        <a
                          className="collapsed card-link accordion-title"
                          data-toggle="collapse"
                          href="#collapsefive"
                        >
                          5. Ophthalmic Sciences Professional
                        </a>
                      </div>
                      <div
                        id="collapsefive"
                        className="collapse"
                        data-parent="#accordion"
                      >
                        <div className="card-body">
                          <table className="table">
                            <tbody>
                              <tr>
                                <th>Profession </th>
                                <th>ISCO Code </th>
                              </tr>
                              <tr>
                                <td>(i) Optometrist</td>
                                <td>2267</td>
                              </tr>
                              <tr>
                                <td>(ii) Ophthalmic Assistant </td>
                                <td>3256</td>
                              </tr>
                              <tr>
                                <td>(iii) Vision Technician </td>
                                <td>3256</td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                    <div className="card">
                      <div className="card-header">
                        <a
                          className="collapsed card-link accordion-title"
                          data-toggle="collapse"
                          href="#collapsesix"
                        >
                          6. Occupational Therapy Professional
                        </a>
                      </div>
                      <div
                        id="collapsesix"
                        className="collapse"
                        data-parent="#accordion"
                      >
                        <div className="card-body">
                          <table className="table">
                            <tbody>
                              <tr>
                                <th>Profession </th>
                                <th>ISCO Code </th>
                              </tr>
                              <tr>
                                <td>Occupational Therapist </td>
                                <td>2269</td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                    <div className="card">
                      <div className="card-header">
                        <a
                          className="collapsed card-link accordion-title"
                          data-toggle="collapse"
                          href="#collapseseven"
                        >
                          7. Community Care, Behavioural Health Sciences and
                          other Professionals
                        </a>
                      </div>
                      <div
                        id="collapseseven"
                        className="collapse"
                        data-parent="#accordion"
                      >
                        <div className="card-body">
                          <table className="table">
                            <tbody>
                              <tr>
                                <th>Community Care </th>
                                <th>ISCO Code </th>
                              </tr>
                              <tr>
                                <td>(i) Environment Protection Officer </td>
                                <td>2133</td>
                              </tr>
                              <tr>
                                <td>(ii) Ecologist </td>
                                <td>2133</td>
                              </tr>
                              <tr>
                                <td>(iii) Community Health promoters </td>
                                <td>3253</td>
                              </tr>
                              <tr>
                                <td>
                                  (iv) Occupational Health and Safety Officer
                                  (Inspector){" "}
                                </td>
                                <td>3257</td>
                              </tr>
                            </tbody>
                          </table>
                          <table className="table mt-3">
                            <tbody>
                              <tr>
                                <th>
                                  Behavioural Health Sciences Professional
                                </th>
                                <th>ISCO Code </th>
                              </tr>

                              <tr>
                                <td>
                                  (i) Psychologist (Except Clinical Psychologist
                                  covered under RCI for PWD){" "}
                                </td>
                                <td>2634</td>
                              </tr>
                              <tr>
                                <td>(ii) Behavioural Analyst </td>
                                <td>2635</td>
                              </tr>
                              <tr>
                                <td>
                                  (iii) Integrated Behaviour Health Counsellor{" "}
                                </td>
                                <td>2635</td>
                              </tr>
                              <tr>
                                <td>
                                  (iv) Health Educator and Counsellors including
                                  Disease Counsellors, Diabetes Educators,
                                  Lactation Consultants{" "}
                                </td>
                                <td>2635</td>
                              </tr>
                              <tr>
                                <td>
                                  (v) Social workers including Clinical Social
                                  Worker, Psychiatric Social Worker, Medical
                                  Social Worker{" "}
                                </td>
                                <td>2635</td>
                              </tr>
                              <tr>
                                <td>
                                  (vi) Human Immunodeficiency Virus (HIV)
                                  Counsellors or Family Planning Counsellors{" "}
                                </td>
                                <td>3259</td>
                              </tr>
                              <tr>
                                <td>(vii) Mental Health Support Workers </td>
                                <td>3259</td>
                              </tr>
                            </tbody>
                          </table>
                          <table className="table mt-3">
                            <tbody>
                              <tr>
                                <th>Other Care Professionals</th>
                                <th>ISCO Code </th>
                              </tr>

                              <tr>
                                <td>(i) Podiatrist</td>
                                <td>2269</td>
                              </tr>
                              <tr>
                                <td>(ii) Palliative Care Professionals </td>
                                <td>3259</td>
                              </tr>
                              <tr>
                                <td>
                                  (iii) Movement Therapist (Including Art, Dance
                                  and Movement Therapist or Recreational
                                  Therapist)
                                </td>
                                <td>2269</td>
                              </tr>
                              <tr>
                                <td>
                                  (iv) Acupuncture Professionals
                                </td>
                                <td>2230, 3230</td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                    <div className="card">
                      <div className="card-header">
                        <a
                          className="collapsed card-link accordion-title"
                          data-toggle="collapse"
                          href="#collapseeight"
                        >
                          8. Medical Radiology, Imaging and Therapeutic
                          Technology Professional
                        </a>
                      </div>
                      <div
                        id="collapseeight"
                        className="collapse"
                        data-parent="#accordion"
                      >
                        <div className="card-body">
                          <table className="table">
                            <tbody>
                              <tr>
                                <th>Profession </th>
                                <th>ISCO Code </th>
                              </tr>
                              <tr>
                                <td>(i) Medical Physicist </td>
                                <td>2111</td>
                              </tr>
                              <tr>
                                <td>(ii) Nuclear Medicine Technologist </td>
                                <td>3211</td>
                              </tr>
                              <tr>
                                <td>
                                  (iii) Radiology and Imaging Technologist
                                  (Diagnostic Medical Radiographer, Magnetic
                                  Resonance Imaging (MRI), Computed Tomography
                                  (CT), Mammographer, Diagnostic Medical
                                  Sonographers){" "}
                                </td>
                                <td>3211</td>
                              </tr>
                              <tr>
                                <td>(iv) Radiotherapy Technologist </td>
                                <td>3211</td>
                              </tr>
                              <tr>
                                <td>(v) Dosimetrist </td>
                                <td>3211</td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                    <div className="card">
                      <div className="card-header">
                        <a
                          className="collapsed card-link accordion-title"
                          data-toggle="collapse"
                          href="#collapsenine"
                        >
                          9. Medical Technologists and Physician Associate
                        </a>
                      </div>
                      <div
                        id="collapsenine"
                        className="collapse"
                        data-parent="#accordion"
                      >
                        <div className="card-body">
                          <table className="table">
                            <tbody>
                              <tr>
                                <th>
                                  Biomedical and Medical Equipment Technology
                                  Professional{" "}
                                </th>
                                <th>ISCO Code </th>
                              </tr>
                              <tr>
                                <td>(i) Biomedical Engineer </td>
                                <td>2149</td>
                              </tr>
                              <tr>
                                <td>(ii) Medical Equipment Technologist </td>
                                <td>3211</td>
                              </tr>
                            </tbody>
                          </table>
                          <table className="table mt-3">
                            <tbody>
                              <tr>
                                <th>
                                  Physician Associate or Physician Assistant{" "}
                                </th>
                                <th>ISCO Code </th>
                              </tr>
                              <tr>
                                <td>(i) Physician Associates </td>
                                <td>3256</td>
                              </tr>
                            </tbody>
                          </table>
                          <table className="table mt-3">
                            <tbody>
                              <tr>
                                <th>
                                  Cardiovascular and Respiratory Technology
                                  Professional{" "}
                                </th>
                                <th>ISCO Code </th>
                              </tr>
                              <tr>
                                <td>(i) Cardiovascular Technologists </td>
                                <td>3259</td>
                              </tr>
                              <tr>
                                <td>(ii) Perfusionist </td>
                                <td>3259</td>
                              </tr>
                              <tr>
                                <td>(iii) Respiratory Technologist </td>
                                <td>3259</td>
                              </tr>
                              <tr>
                                <td>
                                  (iv) Electrocardiogram (ECG) Technologist or
                                  Echocardiogram (ECHO) Technologist{" "}
                                </td>
                                <td>3259</td>
                              </tr>
                              <tr>
                                <td>
                                  (v) Electroencephalogram (EEG) or
                                  Electroneurodiagnostic (END) or
                                  Electromyography (EMG) Technologists or Neuro
                                  Lab Technologists or Sleep Lab Technologists{" "}
                                </td>
                                <td>3259</td>
                              </tr>
                            </tbody>
                          </table>
                          <table className="table mt-3">
                            <tbody>
                              <tr>
                                <th>Renal Technology Professional </th>
                                <th>ISCO Code </th>
                              </tr>
                              <tr>
                                <td>
                                  (i) Dialysis Therapy Technologists or Urology
                                  Technologists{" "}
                                </td>
                                <td>3259</td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                    <div className="card">
                      <div className="card-header">
                        <a
                          className="collapsed card-link accordion-title"
                          data-toggle="collapse"
                          href="#collapseten"
                        >
                          10. Health Information Management and Health
                          Informatic Professional
                        </a>
                      </div>
                      <div
                        id="collapseten"
                        className="collapse"
                        data-parent="#accordion"
                      >
                        <div className="card-body">
                          <table className="table">
                            <tbody>
                              <tr>
                                <th>Profession </th>
                                <th>ISCO Code </th>
                              </tr>
                              <tr>
                                <td>
                                  (i) Health Information Management Professional
                                  (Including Medical Records Analyst){" "}
                                </td>
                                <td>3252</td>
                              </tr>
                              <tr>
                                <td>
                                  (ii) Health Information Management
                                  Technologist{" "}
                                </td>
                                <td>3252</td>
                              </tr>
                              <tr>
                                <td>(iii) Clinical Coder </td>
                                <td>3252</td>
                              </tr>
                              <tr>
                                <td>
                                  (iv) Medical Secretary and Medical
                                  Transcriptionist{" "}
                                </td>
                                <td>3344</td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default AlliedProfessions;
